import { OhsUser } from 'user/OhsUser';
import ModuleHomeUrl from 'dashboard/leftSideDrawer/ModuleHomeUrl';

import OhsBreadcrumbsNameAndRef from './OhsBreadcrumbsNameAndRef';

const OhsBreadCrumbResourceCentre = (
  ohsBreadcrumbsNameAndRef: OhsBreadcrumbsNameAndRef,
  modulePath: string,
  subPath: string,
  viewPath: string,
  operationPath: string,
  user: OhsUser
) => {
  const defaultModuleRef = {
    href: (ModuleHomeUrl[user.tier.type] as any).resourcecentre,
    name: 'Resource Centre',
  };

  if (subPath === 'home') {
    ohsBreadcrumbsNameAndRef.leafName = {
      name: defaultModuleRef?.name,
    };
  } else if (viewPath === 'view') {
    ohsBreadcrumbsNameAndRef.moduleRef = defaultModuleRef;
    ohsBreadcrumbsNameAndRef.leafName = { name: 'View' };
  } else if (operationPath.indexOf('edit') > -1) {
    ohsBreadcrumbsNameAndRef.moduleRef = defaultModuleRef;
    ohsBreadcrumbsNameAndRef.parentOperationRef = {
      href: `/${modulePath}/${subPath}/view`,
      name: 'View',
    };
    ohsBreadcrumbsNameAndRef.leafName = { name: 'Edit' };
  } else if (subPath === 'add') {
    ohsBreadcrumbsNameAndRef.moduleRef = defaultModuleRef;
    ohsBreadcrumbsNameAndRef.leafName = { name: 'Add' };
  }
  return ohsBreadcrumbsNameAndRef;
};
export default OhsBreadCrumbResourceCentre;
